import { EmployeePreferencesByCitizen } from "../../../types/employeeSettings";
import labels from "../../../utils/labels";
import RowCell from "../../UI/table/RowCell";
import EmployeePreferencesRow from "./EmployeePreferencesRow";

const EmployeePreferencesList = ({
  citizens,
}: {
  citizens: EmployeePreferencesByCitizen[];
}) => {
  return (
    <ul className="flex flex-col">
      <li className="flex" data-header>
        <RowCell width={170}>{labels.citizen}</RowCell>
        <RowCell alignment="Middle">{labels.continuityScore}</RowCell>
        <RowCell alignment="Middle">{labels.visitsToday}</RowCell>
        <RowCell alignment="Middle">{labels.preferences}</RowCell>
      </li>
      {citizens.map((citizen) => (
        <EmployeePreferencesRow
          key={citizen.preference.idEmployee}
          citizenName={citizen.citizenName}
          continuityScore={citizen.continuityScore}
          visitsToday={citizen.visitsToday}
          preference={citizen.preference}
        />
      ))}
    </ul>
  );
};

export default EmployeePreferencesList;
